function BrowserPluginPropertyProvider(pluginType, clientConfig) {
    this.getPropertyValue = function() {
        if (clientConfig.browser && clientConfig.browser.plugins) {
            var info = clientConfig.browser.plugins.getInfo(pluginType);

            if (info) {
                if (info.installed) {
                    return info.version;
                }
            } else {
                console.error("Failed to obtain browser plugin details for '" + plugin + '"');
            }
        }

        return "not_installed";
    };
}

module.exports = BrowserPluginPropertyProvider;


//////////////////
// WEBPACK FOOTER
// ./nac/BrowserPluginPropertyProvider.js
// module id = 46
// module chunks = 0